import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from '@mui/material';
import { DialogueCard } from './DialogueCard.js';
export function ModalCard(props) {
    return (_jsx(Modal, { open: props.open ?? false, onClose: props.onClose, style: { width: '100%', height: '100%' }, children: _jsx(DialogueCard, { ...props }) }));
}
//# sourceMappingURL=ModalCard.js.map